module.exports = __webpack_public_path__ + "img/heating-type-02-label-fr.asset.cba5fedd.svg";